import React from 'react';

import {
  Container,
  VerticalSeparator,
  CreditDetailsLink,
  CollorFulBall
} from './styles';
import Skeleton from 'react-loading-skeleton';
interface FloatBarItemProps {
  title: string;
  description: string | React.ReactNode;
  titleColorBall?: string;
  loading?: boolean;
  verticalSeparator?: 'left' | 'right';
  anchorAction?(): void;
}

const BottomBarItem: React.FC<FloatBarItemProps> = ({
  title,
  description,
  verticalSeparator,
  loading,
  anchorAction,
  titleColorBall
}) => {
  return (
    <>
      {verticalSeparator === 'left' && <VerticalSeparator />}

      <Container>
        <span className="title">
          {title}

          {titleColorBall && (
            <CollorFulBall style={{ backgroundColor: titleColorBall }} />
          )}
        </span>

        <span className="description">
          {loading ? <Skeleton /> : description}
        </span>

        {anchorAction && (
          <CreditDetailsLink onClick={anchorAction}>
            Detalhes de crédito
          </CreditDetailsLink>
        )}
      </Container>

      {verticalSeparator === 'right' && <VerticalSeparator />}
    </>
  );
};

export default BottomBarItem;
